export const initialAsyncState = <T>(initialData: T) => ({
  isLoading: false,
  loaded: false,
  data: initialData,
  error: null,
});
